import store from "../src/store";
import httpDriver from "@websanova/vue-auth/dist/drivers/http/axios.1.x.js";
import routerDriver from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js";

const env = process.env.VUE_APP_ENV;

const config = {
  http: httpDriver,
  router: routerDriver,
  loginData: { url: "login" },
  fetchData: {
    url:
      "authuser?includeRelation[]=teams&includeRelation[]=program&includeRelation[]=challenges&includeRelation[]=walkData"
  },
  rolesKey: "roleName",
  refreshData: { enabled: false, url: "refresh" },
  logoutData: { redirect: "/login" },
  tokenStore: ["storage"],
  auth: {
    request: function(req, token) {
      this.http.setHeaders.call(this, req, {
        Authorization: "Bearer " + token
      });
    },

    response: function(res) {
      let token = res.data.token;
      let refreshToken = res.data.refreshToken;

      // refresh token.
      if (refreshToken) {
        localStorage.setItem(
          "auth_refresh_token_default",
          res.data.refreshToken
        );
      }

      if (token) {
        token = token.split(/Bearer:?\s?/i);

        return token[token.length > 1 ? 1 : 0].trim();
      }
    }
  },
  parseUserData(data) {
    let account = {
      id: data.data.programId, // Highly recommended
      name: data.data.program.name // Optional
      // is_paying:    // Recommended if using Pendo Feedback
      // monthly_value:// Recommended if using Pendo Feedback
      // planLevel:    // Optional
      // planPrice:    // Optional
      // creationDate: // Optional
      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
    };

    // NOTE: PENDO WRITTEN COMMENTS BELOW
    // in your authentication promise handler or callback
    if (
      data.data.roleName.includes("ProductAdmin") &&
      process.env.NODE_ENV === "production"
    ) {
      window.pendo.initialize({
        visitor: {
          id: `${data.data.id}-${env}`, // Required if user is logged in. (appending env as per guidance of pendo: differentiates our users & possible duplicated ids)
          email: data.data.email, // Recommended if using Pendo Feedback, or NPS Email
          full_name: data.data.name, // Recommended if using Pendo Feedback
          role: data.data.roleName // Optional

          // You can add any additional visitor level key-values here,
          // as long as it's not one of the above reserved names.
        },

        account
      });
    }
    if (data.data.teams.length && data.data.teams[0].isTeamLeader) {
      store.dispatch("authMember/setIsTeamLeader", true);
    } else {
      store.dispatch("authMember/setIsTeamLeader", false);
    }
    store.dispatch("authMember/setAdminType", data.data.adminLevel);
    store.dispatch("program/setProgram", data.data.program);
    return data.data;
  }
};

export default config;
